import { Box, LoadingOverlay, Text } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';
import { useLoadDso } from 'shared/hooks/use-load-dso';

import { AnalyticsCard } from '../AnalyticsCard';
import { DsoChart } from '../charts';

export const DsoCard = () => {
  const { t } = useTranslation();
  const { dso = { current_year: {}, previous_year: {} }, isDsoLoading } = useLoadDso();

  return (
    <AnalyticsCard
      title={t(i18nKeys.ANALYTICS.DSO.TITLE)}
      helpContent={<DsoHelpContent />}
      panelProps={{
        pb: 'space6', // override the padding to make the legend look better
      }}
    >
      <Box w="100%" h="400px">
        {isDsoLoading ? <LoadingOverlay visible /> : <DsoChart dso={dso} />}
      </Box>
      <Box id="dso-legend-outlet" />
    </AnalyticsCard>
  );
};

const DsoHelpContent = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Text fw="bold">{t(i18nKeys.ANALYTICS.DSO.HELP.TITLE)}</Text>
      <br />
      <Text>{t(i18nKeys.ANALYTICS.DSO.HELP.LINE_1)}</Text>
    </Box>
  );
};
